import { gql } from '@apollo/client';
import { TeamleaderCompany } from '../types/integration_settings/common/Teamleader';

const fetchCompanies = gql`
  query TeamleaderFetchCompanies {
    teamleaderFetchCompanies {
      id
      name
    }
  }
`;

export interface TeamleaderFetchCompaniesVariables {}

export interface TeamleaderFetchCompaniesResponse {
  teamleaderFetchCompanies: TeamleaderCompany[];
}

const fetchReferenceData = gql`
  mutation teamleaderFetchReferenceData {
    teamleaderFetchReferenceData
  }
`;

export interface TeamleaderFetchReferenceDataVariables {}

export interface TeamleaderFetchReferenceDataResponse {
  teamleaderFetchReferenceData: boolean;
}

const fetchProducts = gql`
  mutation teamleaderFetchProducts {
    teamleaderFetchProducts
  }
`;

export interface TeamleaderFetchProductsVariables {}

export interface TeamleaderFetchProductsResponse {
  teamleaderFetchProducts: boolean;
}

const fetchContacts = gql`
  mutation teamleaderFetchContacts {
    teamleaderFetchContacts
  }
`;

export interface TeamleaderFetchContactsVariables {}

export interface TeamleaderFetchContactsResponse {
  teamleaderFetchContacts: boolean;
}

const createCustomFields = gql`
  mutation teamleaderCreateCustomFields {
    teamleaderCreateCustomFields
  }
`;

export interface TeamleaderCreateCustomFieldsVariables {}

export interface TeamleaderCreateCustomFieldsResponse {
  teamleaderCreateCustomFields: boolean;
}

const createStockLocations = gql`
  mutation teamleaderCreateStockLocations {
    teamleaderCreateStockLocations
  }
`;

export interface TeamleaderCreateStockLocationsVariables {}

export interface TeamleaderCreateStockLocationsResponse {
  teamleaderCreateStockLocations: boolean;
}

const createBins = gql`
  mutation teamleaderCreateBins {
    teamleaderCreateBins
  }
`;

export interface TeamleaderCreateBinsVariables {}

export interface TeamleaderCreateBinsResponse {
  teamleaderCreateBins: boolean;
}

const createWebhooks = gql`
  mutation teamleaderCreateWebhooks {
    teamleaderCreateWebhooks
  }
`;

export interface TeamleaderCreateWebhooksVariables {}

export interface TeamleaderCreateWebhooksResponse {
  teamleaderCreateWebhooks: boolean;
}

export const TeamleaderQueries = {
  fetchCompanies,
};

export const TeamleaderMutations = {
  fetchReferenceData,
  fetchProducts,
  fetchContacts,
  createCustomFields,
  createStockLocations,
  createBins,
  createWebhooks,
};
